import { createSlice } from '@reduxjs/toolkit';

import socket from '../../utils/socket';

const initialState = {
  companies: [],
  company: {},
  companyId: 0,
  error: false,
  isLoading: false
};

const slice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getCompany(state, action) {
      const { company } = action.payload;
      const [firstCompany = {}] = company;
      state.company = firstCompany;
      state.isLoading = false;
    },

    /**
     * Pour l'appel à la racine (appelé par App.jsx), on récupère toutes les entreprises
     * On récupère la première entreprise pour l'affichage
     * Cette méthode est nécessaire pour les clients qui ont plusieurs entreprises (multi-entreprises)
     * Elle ne semble pas avoir d'incidence sur le reste des comportements car les autres appels à getCompany
     * ne vise qu'une seule société.
     */
    getCompanies(state, action) {
      const { company } = action.payload;
      const [firstCompany = {}] = company;
      state.company = firstCompany;
      state.companies = company;
      state.isLoading = false;
    },

    onSelectCompany(state, action) {
      state.companyId = parseInt(action.payload, 10);
      state.company = find(state.companies, (el) => el.id === state.companyId);
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onSelectCompany } = slice.actions;

export function getCompany(companyId = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/company/infos', { companyId });
      dispatch(slice.actions.getCompany(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompanies() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/company/infos');
      dispatch(slice.actions.getCompanies(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
